<div *ngIf="formErrors && cnfJson.showFormErrors" class="alert alert-danger">
  {{ formErrors | json }}
</div>

<div *ngIf="atividade" class="ibox-content-container" [class.is-mobile]="isMobile" [class.black]="enTheme === 'black'">
  <!-- Save ou Confirm -->
  <div *ngIf="hasConfirm" class="box-a">
    <button mat-raised-button type="button" [class.btn-mobile]="isMobile" (click)="onConfirm($event, saveInList)" color="primary" [disabled]="isLoading">
      <mat-icon>check_circle</mat-icon>
      {{ textConfirm }}
    </button>

    <button mat-raised-button *ngIf="isEdit && _atividade.AtividadeNo == 24666" class="bnt-delete" [class.btn-mobile]="isMobile" (click)="onDelete($event)">
      <mat-icon>delete</mat-icon>
      Apagar
    </button>
  </div>

  <div *ngIf="hasSave" class="box-b">
    <button mat-raised-button type="submit" [class.btn-mobile]="isMobile" (submit)="clicked()" color="primary" [disabled]="isLoading || disable">
      <mat-icon>done</mat-icon>
      {{ textSave }}
    </button>
  </div>

  <div *ngIf="hasSaveAndNew" class="box-c text-left">
    <button mat-raised-button type="button" [class.btn-mobile]="isMobile" (click)="onSaveAndNew($event)" color="primary" [disabled]="isLoading">
      <mat-icon>done_outline</mat-icon>
      {{ textSaveAndNew }}
    </button>
  </div>

  <div *ngIf="hasDuplicate" class="box-d text-left">
    <button mat-raised-button type="button" [class.btn-mobile]="isMobile" (click)="onDuplicate($event)" color="primary" [disabled]="isLoading">
      <mat-icon>file_copy</mat-icon>
      {{ textDuplicate }}
    </button>
  </div>
</div>
